/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-danger */
/* eslint-disable no-lonely-if */
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {LetrusApi} from '@letrustech/letrus-api-interfaces';
import GeneralErrorModal from 'components/GeneralErrorModal';
import PageLoading from 'components/PageLoading';
import Stepper from 'components/Stepper';
import useLearningPathNavigation from 'features/useLearningPathNavigation';
import {NewButton} from 'components/ui';
import {useEffect, useState} from 'react';
import {connect, useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';
import {
  finishPedagogicalContentStepRequest,
  getLearningPathStepRequestStatus,
} from 'store/reducers/learningPath';
import {
  fetchPedagogicalContentByIdRequest,
  getPedagogicalContentById,
  isLoadingPedagogicalContent,
} from 'store/reducers/pedagogicalContents';
import {ApplicationState} from 'store/rootReducer';
import {timerSetup} from 'utils/functions/timer';
import {useQueryParam} from 'utils/hooks';
import useTrackEvent from 'utils/hooks/useTrackEvent';
import {EventData} from 'utils/hooks/useTrackEvent/types';
import {getUserData} from 'utils/functions/getUserData/getUserData';
import {useModals} from 'letrus-ui';
import styles from './PedagogicalContent.module.scss';

interface DispatchProps {
  fetchPedagogicalContentByIdRequest: typeof fetchPedagogicalContentByIdRequest;
  finishPedagogicalContentStepRequest: typeof finishPedagogicalContentStepRequest;
}

interface StateProps {
  pedagogicalContent: ImmutableMap<LetrusApi.PedagogicalContentNested>;
  isLoadingPedagogicalContent: boolean;
}

export type PedagogicalContentProps = DispatchProps & StateProps;

const OLYMPICS_PEDAGOGICAL_CONTENT_ID = 474;

const PedagogicalContent: React.FC<PedagogicalContentProps> = ({
  pedagogicalContent,
  isLoadingPedagogicalContent,
  fetchPedagogicalContentByIdRequest,
  finishPedagogicalContentStepRequest,
}) => {
  const navigate = useNavigate();
  const queryParams = useQueryParam();
  const pedagogicalContentTimer = timerSetup();
  const pedagogicalContentStatus = useSelector(
    getLearningPathStepRequestStatus,
  );
  const learningPathUserInstanceId = queryParams.get('trilha') ?? '';
  const {trackEvent, trackDocumentEvent} = useTrackEvent();
  const {pedagogical_content_id} = useParams();
  const [hasScrolledToEnd, setHasScrolledToEnd] = useState(false);
  const [startOlympicExperience, setStartOlympicExperience] = useState(false);
  const {learningPath, navigateToLearningPath} = useLearningPathNavigation(
    learningPathUserInstanceId,
  );
  const {user} = getUserData();

  const modals = useModals(['error']);

  const olympicLinkToReplace = `https://demo.letrus.com.br/?external_id=${user.id}`;
  const isOlympicContent =
    Number(pedagogical_content_id) === OLYMPICS_PEDAGOGICAL_CONTENT_ID;

  const eventData: EventData = {
    pedagogicalContent: {
      pedagogical_content_learning_path_user_instance_id: learningPath?.id,
      pedagogical_content_id: Number(pedagogical_content_id),
    },
    ...(learningPath
      ? {
          learningPathUserInstance: {
            learning_path_user_instance_id: learningPath.id,
            step_id:
              learningPath.steps?.find(
                (step) => step.order === learningPath.step_number,
              )?.id || 0,
          },
        }
      : {}),
  };

  function getContent() {
    if (pedagogicalContent.get('content_html') && isOlympicContent) {
      if (!startOlympicExperience) {
        return '';
      }
      return pedagogicalContent
        .get('content_html')
        .replace('https://demo.letrus.com.br/', `${olympicLinkToReplace}`);
    }

    return pedagogicalContent.get('content_html');
  }

  function fullscreen() {
    const documentApi = document as any;
    if (
      (documentApi.fullScreenElement &&
        documentApi.fullScreenElement !== null) ||
      (!documentApi.mozFullScreen && !documentApi.webkitIsFullScreen)
    ) {
      if (documentApi.documentElement.requestFullScreen) {
        documentApi.documentElement.requestFullScreen();
      } else if (documentApi.documentElement.mozRequestFullScreen) {
        documentApi.documentElement.mozRequestFullScreen();
      } else if (documentApi.documentElement.webkitRequestFullScreen) {
        documentApi.documentElement.webkitRequestFullScreen(
          (Element as any).ALLOW_KEYBOARD_INPUT,
        );
      }
    } else {
      if (documentApi.cancelFullScreen) {
        documentApi.cancelFullScreen();
      } else if (documentApi.mozCancelFullScreen) {
        documentApi.mozCancelFullScreen();
      } else if (documentApi.webkitCancelFullScreen) {
        documentApi.webkitCancelFullScreen();
      }
    }
  }

  useEffect(() => {
    fetchPedagogicalContentByIdRequest(pedagogical_content_id);

    if (learningPathUserInstanceId) {
      trackEvent('finished_pedagogical_content_view', eventData);
    }

    trackDocumentEvent({
      eventType: 'onselectionchange',
      eventName: 'selected_pedagogical_content_text',
      eventData,
      eventCallback: () => ({
        supportingContent: {
          selected_text: window.getSelection()?.toString() || '',
        },
      }),
    });

    trackDocumentEvent({
      eventType: 'oncopy',
      eventName: 'copied_pedagogical_content_text',
      eventData,
      eventCallback: () => ({
        supportingContent: {
          selected_text: window.getSelection()?.toString() || '',
        },
      }),
    });
  }, []);

  useEffect(() => {
    if (hasScrolledToEnd) {
      trackEvent('scrolled_to_end_of_pedagogical_content', eventData);
    }
  }, [hasScrolledToEnd]);

  useEffect(() => {
    if (
      pedagogicalContentStatus.errorMessage ===
      'O Passo atual da trilha não é um conteúdo pedagógico.'
    ) {
      modals.error?.showModal();
    }
  }, [pedagogicalContentStatus]);

  function finishPedagogicalContent() {
    trackEvent('time_spent_on_pedagogical_content', {
      ...eventData,
      time: {
        spent_time: pedagogicalContentTimer.finish(),
      },
    });

    if (learningPathUserInstanceId) {
      finishPedagogicalContentStepRequest(learningPathUserInstanceId);
      navigateToLearningPath.nextStep(Number(pedagogical_content_id));
    } else {
      navigate('/');
    }
  }

  function handlePageReturn() {
    if (learningPathUserInstanceId) {
      navigateToLearningPath.previousStep(Number(pedagogical_content_id));
    } else {
      navigate(-1);
    }
  }

  function onScroll(event) {
    if (setHasScrolledToEnd) {
      const sidebar = event.target;

      if (sidebar.scrollHeight - sidebar.scrollTop === sidebar.clientHeight) {
        setHasScrolledToEnd(true);
      }
    }
  }

  return isLoadingPedagogicalContent ? (
    <PageLoading />
  ) : (
    <div className={styles.content} onScroll={onScroll}>
      <div className={styles.header}>
        <div
          className={styles.questionnaireInfo}
          role="button"
          tabIndex={0}
          data-testid="returnButton"
          onClick={handlePageReturn}
        >
          <FontAwesomeIcon icon="angle-left" />
          <div>
            <h2 className={styles.title}>{learningPath?.name}</h2>
            <p className={styles.subtitle}>{pedagogicalContent.get('title')}</p>
          </div>
        </div>
        <div className={styles.stepperWrapper}>
          <Stepper
            learningPath={learningPath}
            onStepClick={navigateToLearningPath.stepByOrder}
          />
        </div>
      </div>
      <div className={styles.contentWrapper}>
        <div
          className={`${styles.contentHtml} ${
            pedagogicalContent.get('content_html') &&
            isOlympicContent &&
            styles.olympicContent
          }`}
          dangerouslySetInnerHTML={{
            __html: getContent(),
          }}
        />
        <div className={styles.footer}>
          <NewButton
            text="Continuar"
            size="small"
            kind="primary"
            onClick={finishPedagogicalContent}
            userRole="student"
          />
        </div>
      </div>

      <GeneralErrorModal
        id="error"
        title="Erro!"
        subTitle="A etapa anterior não foi concluída"
        description="Você pode ter um questionário e/ou escrita que não foi finalizado. Se você tiver um questionário, verifique e garanta que passou e respondeu todas as questões. Se você tiver uma escrita nessa atividade, garanta que o texto foi enviado"
        showIcon={false}
      />
    </div>
  );
};

export default connect(
  (state: ApplicationState) => ({
    pedagogicalContent: getPedagogicalContentById(state),
    isLoadingPedagogicalContent: isLoadingPedagogicalContent(state),
  }),
  {
    fetchPedagogicalContentByIdRequest,
    finishPedagogicalContentStepRequest,
  },
)(PedagogicalContent);
